module.exports = __webpack_public_path__ + "img/5.abe4b9bb.png";